import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

function getStoredToken() {
  return localStorage.getItem("crm_access_token");
}

function setStoredTokens(access, refresh) {
  localStorage.setItem("crm_access_token", access);
  if (refresh) localStorage.setItem("crm_refresh_token", refresh);
}

function clearStoredTokens() {
  localStorage.removeItem("crm_access_token");
  localStorage.removeItem("crm_refresh_token");
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = getStoredToken();
    if (!token) { setUser(false); setLoading(false); return; }
    try {
      const { data } = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      setUser(data);
    } catch {
      clearStoredTokens();
      setUser(false);
    }
    setLoading(false);
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password });
    setStoredTokens(data.access_token, data.refresh_token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    clearStoredTokens();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be inside AuthProvider");
  return ctx;
}
